import axios from 'axios';

// Axios instance voor je eigen API
export const axiosInstance = axios.create({
    baseURL: `${import.meta.env.VITE_APIURL}`,
});

// Axios instance voor Foodbook API
export const foodbookInstance = axios.create({
    baseURL: `${import.meta.env.VITE_FOODBOOKURL}`,
    headers: {
        'Content-Type': 'application/json',
    }
});

// Request interceptor
axiosInstance.interceptors.request.use(
    (config) => {
        // Skip token voor login en refresh requests
        if (!config.url.includes('/auth/login') && !config.url.includes('/auth/refresh')) {
            const token = localStorage.getItem('token');
            if (token) {
                config.headers['Authorization'] = `Bearer ${token}`;
            }
        }

        const menuId = parseInt(localStorage.getItem('selectedMenu')) || 0;
        config.headers['MenuId'] = menuId;

        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Response interceptor voor error handling en token refresh
axiosInstance.interceptors.response.use(
    (response) => response,
    async (error) => {
        const originalRequest = error.config;

        // Als het een login request is, geef de error direct door
        if (originalRequest.url.includes('/auth/login')) {
            return Promise.reject(error);
        }

        // Voor andere requests, probeer token refresh bij 401
        if (error.response?.status === 401 && !originalRequest._retry) {
            originalRequest._retry = true;

            try {
                const token = localStorage.getItem('token');
                const refreshToken = localStorage.getItem('refreshToken');

                if (!token || !refreshToken) {
                    throw new Error('No tokens available for refresh');
                }

                const response = await axiosInstance.post('/auth/refresh', {
                    accesstoken: token,
                    refreshtoken: refreshToken
                });

                if (response.data.accesstoken && response.data.refreshtoken) {
                    localStorage.setItem('token', response.data.accesstoken);
                    localStorage.setItem('refreshToken', response.data.refreshtoken);

                    originalRequest.headers['Authorization'] = `Bearer ${response.data.accesstoken}`;
                    return axiosInstance(originalRequest);
                } else {
                    throw new Error('Invalid refresh token response');
                }
            } catch (refreshError) {
                console.error('Token refresh failed:', refreshError);
                localStorage.clear();
                window.location.href = '/';
                return Promise.reject(refreshError);
            }
        }

        return Promise.reject(error);
    }
);

export default axiosInstance;